import "./FoodAndPharmaceuticalFiltration.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import FoodPharmaHero from "./sections/FoodPharmaHero";
import FoodPharmaOverview from "./sections/FoodPharmaOverview";
import FoodProcessingPanel from "./sections/FoodProcessingPanel";
import PharmaceuticalPanel from "./sections/PharmaceuticalPanel";
import Compliance from "./sections/Compliance";
import RecommendedProducts from "./sections/RecommendedProducts";
import RelatedArticles from "@/components/common/RelatedArticles";
import CtaBand from "@/components/common/CtaBand";
import Footer from "@/reusable_sections/Footer";
import useHashScroll from "@/hooks/useHashScroll";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface CtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
}
const closingCtaCopy: Record<Lang, CtaCopy> = {
  en: {
    eyebrow: "Food & Pharmaceutical Filtration",
    heading: "Need Hygienic Wire Mesh for Sanitary Processing?",
    lead: "Share your micron rating, alloy requirements, and element dimensions for quotation and technical validation.",
    secondaryLabel: "Contact Our Engineers"
  },
  zh: {
    eyebrow: "食品与制药过滤",
    heading: "需要用于卫生级工艺的不锈钢过滤丝网？",
    lead: "请提供所需的过滤精度、合金材质及组件规格尺寸，获取针对性的报价与工艺核算方案。",
    secondaryLabel: "联系技术团队"
  },
  es: {
    eyebrow: "Filtración alimentaria y farmacéutica",
    heading: "¿Necesita malla higiénica para procesos sanitarios?",
    lead: "Indique la retención en micras, la aleación requerida y las dimensiones para recibir una cotización técnica.",
    secondaryLabel: "Contactar con ingenieros"
  },
  de: {
    eyebrow: "Lebensmittel- und Pharmafiltration",
    heading: "Benötigen Sie hygienisches Drahtgewebe für Sanitärprozesse?",
    lead: "Teilen Sie uns Ihre geforderte Filterfeinheit, Legierung und Abmessungen für ein technisches Angebot mit.",
    secondaryLabel: "Ingenieure kontaktieren"
  },
  fr: {
    eyebrow: "Filtration agroalimentaire et pharmaceutique",
    heading: "Besoin de toile métallique hygiénique pour procédés sanitaires ?",
    lead: "Transmettez votre seuil de coupure, la nuance d'alliage et les dimensions pour un devis technique détaillé.",
    secondaryLabel: "Contacter nos ingénieurs"
  },
  pt: {
    eyebrow: "Filtração de alimentos e farmacêutica",
    heading: "Precisa de tela higiênica para processos sanitários?",
    lead: "Envie sua micragem, requisitos de liga e dimensões do elemento para orçamento e validação técnica.",
    secondaryLabel: "Falar com engenheiros"
  }
};
export default function FoodAndPharmaceuticalFiltrationPage() {
  useHashScroll();
  const {
    lang
  } = useLanguage();
  const cta = pick(lang, closingCtaCopy);
  return <div>
      <Header />
      <PageBreadcrumb page="FoodAndPharmaceuticalFiltration" />
      <FoodPharmaHero />
      <FoodPharmaOverview />
      <FoodProcessingPanel />
      <PharmaceuticalPanel />
      <Compliance />
      <RecommendedProducts />
      <RelatedArticles topic="food" />
      <CtaBand id="food-pharma-closing-cta" eyebrow={cta.eyebrow} heading={cta.heading} lead={cta.lead} primary={{
      label: pick(lang, COMMON.requestQuote),
      to: "/RequestAQuotePage"
    }} secondary={{
      label: cta.secondaryLabel,
      to: "/ContactPage"
    }} />
      <Footer />
    </div>;
}